import { UI_CLIENTS } from 'src/constants/GlobalConstants';
import { DocumentDetails, IAPIMetadata, IAPIPagination } from './CommonTypes';

export interface IViewCaseRequest {
  userId: string;
  accountId: string;
  authorizationToken?: string;
  caseId: string;
  clientId: string;
}

export interface IViewCaseResponse {
  caseId: string;
  userId: string;
  accountId: string;
  ddmSchemaId: string;
  ddmSchemaVersion: string;
  caseTitle: string;
  data: any;
  caseOverviewData?: any;
  documentList?: Array<DocumentDetails>;
}
export interface ICreateCaseRequest extends IAPIMetadata {
  userId: string;
  accountId: string;
  clientId: string;
  ddmSchemaId: string;
  ddmSchemaVersion: string;
  caseTitle: string;
  caseLocale?: string;
  data: string;
  authorizationToken?: string;
  documentList: Array<DocumentDetails>;
}

export enum CaseUpdateType {
  CASE_OVERVIEW_UPDATE = 'CASE_OVERVIEW_UPDATE',
}
export interface IUpdateCaseRequest extends IAPIMetadata {
  userId: string;
  caseId: string;
  accountId: string;
  clientId: string;
  caseTitle?: string;
  data?: string;
  ddmSchemaId?: string;
  ddmSchemaVersion?: string;
  caseUpdateTypeList: CaseUpdateType[];
  caseOverviewData?: string;
}

export interface IUpdateCaseResponse {
  caseId: string;
}

export interface IGetCaseListRequest {
  userId: string;
  accountId: string;
  pageSize?: number;
  nextToken?: string;
  authorizationToken?: string;
  clientId: string;
}

export interface IGetCaseListItem {
  caseId: string;
  caseTitle: string;
  createdByUser: string;
  createdOn: number;
  lastUpdatedByUser: string;
  marketplaceId: string;
  caseStatus?: string;
  lastUpdatedOn: number;
  assignee?: string;
  caseLocale?: string;
  paragonCaseIds?: string;
}

export interface IGetCaseListResponse {
  caseDetails: IGetCaseListItem[];
  nextToken: string;
}

export interface IUserIdentity {
  userId: string;
  authToken: string;
  ubId: string;
  attributes: Record<string, any>;
  type: IdentityTypes;
}

export enum IdentityTypes {
  RETAIL_CUSTOMER_ID = 'RetailCustomerId',
  EXTERNAL_CUSTOMER_EMAIL = 'CustomerEmail',
  INTERNAL_USER_ALIAS = 'InternalUserAlias',
}
export interface IUserAccountResponse {
  userId: string;
  accountList: Array<string>;
}

export type ResourceType = 'LENS-UMS-Account';

export interface ResourceAttributesIdentifiers {
  accountName: string;
  domain: string;
  country: string;
  role: string;
}

export interface ResourceAttributes {
  id: string;
  type: ResourceType;
  attributes: ResourceAttributesIdentifiers;
}

export interface IUserIdentityMetadata {
  identity: Partial<IUserIdentity>;
}
export interface IGetUserAuthorizedForResourcesRequest
  extends IAPIMetadata,
    IUserIdentityMetadata {
  resourceType: string;
}

export interface IGetUserAuthorizedForResourcesResponse {
  resourceList: ResourceAttributes[];
  userId: string;
}

export interface IGetUsersForAccountRequest extends IAPIPagination {
  accountType: ResourceType;
  accountId: string;
  clientId: UI_CLIENTS;
}

export interface IGetUsersForAccountResponse {
  userDetailsList: UserDetails[];
}

export interface UserDetails {
  userId: string;
  fullName: string;
  primaryEmail: string;
  marketPlaceId: string;
  isInternalUser: boolean;
  role: string;
}

export interface AccountAttribute {
  accountId: string;
  accountType: ResourceType;
}
export interface IAddUserToAccountRequest
  extends IAPIMetadata,
    IUserIdentityMetadata {
  user: Partial<IUserIdentity>;
  account: AccountAttribute;
  clientId: UI_CLIENTS;
}

export interface IRemoveUserFromAccountRequest
  extends IAPIMetadata,
    IUserIdentityMetadata {
  user: Partial<IUserIdentity>;
  account: AccountAttribute;
  clientId: UI_CLIENTS;
}

export interface IRemoveUserFromAccountResponse {
  message: string;
}
